/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconSize} from '../types/types';
import useIconSize from './useIconSize';
import {useImpactIconColor} from './useImpactIconColor';

interface BottomImpactIconProps {
  size?: IconSize | number;
  color?: string;
}

/*
 * Defines the Design Language System (DLS) Bottom Impact Icon component for the
 * SC Device Shock Sensor widget.
 */
export const BottomImpactIcon = ({size = 140}: BottomImpactIconProps) => {
  const {red, blue, green, paleBlue} = useImpactIconColor();
  const iconSize                     = useIconSize(size);

  return (
    <svg width={iconSize} height={iconSize} viewBox="0 0 131 145" fill="none" xmlns="http://www.w3.org/2000/svg">
      <line y1="126.998" x2="130.558" y2="126.998" stroke={red} strokeWidth="3" />
      <rect y="127.769" width="130.558" height="16.7756" fill={paleBlue} />
      <path d="M37.9043 19.3633L92.6535 19.3633C96.5194 19.3633 99.6535 22.4973 99.6535 26.3633V124.581H30.9043L30.9043 26.3633C30.9043 22.4973 34.0383 19.3633 37.9043 19.3633Z" fill={paleBlue} stroke={green} strokeWidth="2" />
      <path d="M53.9506 32.4912H76.6073C80.4733 32.4912 83.6073 35.6252 83.6073 39.4912V112.181H46.9506L46.9506 39.4912C46.9506 35.6252 50.0846 32.4912 53.9506 32.4912Z" fill={dlsColor('white')} stroke={green} strokeWidth="2" />
      <mask id="mask0_304_22940" style={{maskType: 'alpha'}} maskUnits="userSpaceOnUse" x="13" y="90" width="104" height="36">
        <rect x="13" y="90" width="104" height="36" fill={red} />
      </mask>
      <g mask="url(#mask0_304_22940)">
        <line x1="12.3994" y1="126.496" x2="118.158" y2="126.496" stroke={red} strokeWidth="2" />
        <path d="M37.9042 19.3613L92.6534 19.3613C96.5194 19.3613 99.6534 22.4953 99.6534 26.3613V125.308H30.9042L30.9042 26.3613C30.9042 22.4953 34.0382 19.3613 37.9042 19.3613Z" fill={paleBlue} stroke={red} strokeWidth="2" />
        <path d="M53.9505 32.4893H76.6073C80.4732 32.4893 83.6073 35.6233 83.6073 39.4893V112.179H46.9505L46.9505 39.4893C46.9505 35.6233 50.0845 32.4893 53.9505 32.4893Z" fill={dlsColor('white')} stroke={red} strokeWidth="2" />
      </g>
      <line x1="12.8994" y1="0.857422" x2="12.8994" y2="125.58" stroke={blue} strokeDasharray="2 2" />
      <line x1="117.929" y1="0.857422" x2="117.929" y2="125.58" stroke={blue} strokeDasharray="2 2" />
      <line x1="12.3994" y1="89.3418" x2="116.7" y2="89.3418" stroke={blue} strokeDasharray="2 2" />
      <line x1="12.3994" y1="1.08691" x2="116.7" y2="1.08691" stroke={blue} strokeDasharray="2 2" />
      <path d="M13 126H117V90H13V126Z" fill={red} fillOpacity="0.2" />
    </svg>
  );
};
